(function ($, Drupal) {

  'use strict';

  function onDocNodeBlogReady(context) {
    const $elements = $(once('initializeNodeBlogBehavior', 'body', context));
    $elements.each(function() {

      $('.blog-cta .btn').on('click', function() {
        var dataFormValue = $(this).attr('data-form-value');
        if (dataFormValue) {
          $('.concorde_webform_campus_area_program_program').val(dataFormValue);
        }
      });

    });
  }

  Drupal.behaviors.initializeNodeBlog = {
    attach: function (context) {
      onDocNodeBlogReady(context);
    }
  };

})(jQuery, Drupal);
